import axios from "axios";
import { ATP_API_URL } from "@config/apiconfig";
import apiClient from "@services/apiClient";

export const loginWithCredentialsAPI = async (email, password) => {
  try {
    const response = await axios.post(`${ATP_API_URL.LOGIN}`, {
      email,
      password,
    });

    if (response?.status) {
      return {
        success: true,
        message: "OTP sent to your email",
        user: response,
      };
    } else {
      return {
        success: false,
        message: "Invalid email or password. Please check your credentials.",
        user: response,
      };
    }
  } catch (error) {
    throw error;
  }
};

export const verifyOTPAPI = async (email, otp) => {
  try {
    const payload = {
      email,
      otp,
    };

    const response = await apiClient.post(`${ATP_API_URL.VERIFY_OTP}`, payload);

    if (response.status) {
      return {
        success: true,
        otpValidationDetails: response,
      };
    } else {
      return {
        success: false,
        message: "Invalid OTP. Please check and try again.",
      };
    }
  } catch (error) {
    throw error;
  }
};

export const resendOTPAPI = async (email) => {
  try {
    const payload = {
      email,
    };

    const response = await apiClient.post(`${ATP_API_URL.RESEND_OTP}`, payload);

    if (response.status) {
      return {
        success: true,
        message: `OTP has been resent to ${email}`,
      };
    } else {
      return {
        success: false,
        message: "Email not found in our records.",
      };
    }
  } catch (error) {
    throw new Error("Failed to resend OTP. Please try again.");
  }
};
